import React from "react";
import { Box, AHText, AHIcon } from "arkh";
import { FormattedMessage } from "react-intl";
import * as Device from "expo-device";

export const DEVICE_HAS_SCANNER = Device.brand === "Zebra";

function ScanLabelContainer(props: { children: React.ReactNode }) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <AHIcon
        type="barcode-scanner"
        color="primary"
        forceSize={12}
        spaceRight="xsmall"
      />
      <AHText color="primary" type="detail">
        {props.children}
      </AHText>
    </Box>
  );
}

export function ScanToOpenProductLabel() {
  return (
    <ScanLabelContainer>
      <FormattedMessage
        defaultMessage="Scan to open product"
        description="Scan to open product label"
      />
    </ScanLabelContainer>
  );
}

export function ScanToAddExpireDate() {
  return (
    <ScanLabelContainer>
      <FormattedMessage
        defaultMessage="Scan to add expire date"
        description="Scan to add expire date label"
      />
    </ScanLabelContainer>
  );
}
